"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieAcceptButton = exports.CookiesDisclaimerWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const core_basis_bs_button_1 = require("@hotelplan/core.basis.bs-button");
exports.CookiesDisclaimerWrapper = styled_components_1.default.div(({ theme }) => theme.metaModules.cookies.wrap, ({ theme }) => ({
    display: 'flex',
    '.cookies-disclaimer-text': theme.metaModules.cookies.text,
}));
exports.CookieAcceptButton = (0, styled_components_1.default)(core_basis_bs_button_1.BsButton)(({ theme }) => theme.metaModules.cookies.acceptButton);
//# sourceMappingURL=fdr-cookie-disclaimer.styles.js.map